import { Inlines } from '../Inlines';

export default function ParagraphBlock({ block }) {
  return (
    <p className="content-paragraph">
      <Inlines nodes={block.children} />
    </p>
  );
}
